import React from 'react'
import debounce from 'lodash/debounce'
import moment from 'moment'
import { css, cx } from 'emotion'
import spinner from '@pndr/spinner'
import arrowLeft from '@pndr/icons/lib/arrowLeft'
import arrowRight from '@pndr/icons/lib/arrowRight'
import api from '../services/api'
import Box from '../components/Box'
import ContractMonthChart from '../components/ContractMonthChart'
import ContractMonthDTGCard from '../components/ContractMonthDTGCard'
import ContractMonthDebtorTrajectoryDayCountCard from '../components/ContractMonthDebtorTrajectoryDayCountCard'
import ContractMonthDebtorTrajectoryCountCard from '../components/ContractMonthDebtorTrajectoryCountCard'
import ContractYearChart from '../components/ContractYearChart'
import ContractYearDTGCard from '../components/ContractYearDTGCard'
import ContractYearDebtorTrajectoryDayCountCard from '../components/ContractYearDebtorTrajectoryDayCountCard'
import ContractYearDebtorTrajectoryCountCard from '../components/ContractYearDebtorTrajectoryCountCard'
class SegmentedControlItem extends React.Component {

    state = {
        hover: false
    }

    render() {

        return (
            <div
                className={cx(
                    css`
                    background-color: #fff;
                    border-right: 1px solid #f2f2f2;
                    padding: 8px 7px;
                    cursor: pointer;
                    &:hover {
                        background-color: rgba(0,119,255,.1);
                    }
                    &:last-of-type {
                        border-right: none;
                    }
                `
                )}
                style={{
                    width: this.props.width ? this.props.width : 'auto'
                }}
                onMouseEnter={() => this.setState({ hover: true })}
                onMouseLeave={() => this.setState({ hover: false })}
                onClick={(e) => this.props.onClick({ e, id: this.props.id })}
            >
                <div
                    className={cx(
                        css`
                        font-size: 14px;
                        color: ${this.props.active || this.state.hover ? '#07f' : '#4d4d4d'};
                        font-weight: ${this.props.description || this.props.active ? '700' : '400'};
                        letter-spacing: ${this.props.active ? '0' : '0.252px'};
                        text-align: center;
                    `,
                        this.props.description ? css`
                        margin-bottom: 4px;
                    ` : null
                    )}
                >
                    {this.props.name}
                </div>
                {this.props.description ? (
                    <div
                        className={css`
                        font-size: 12px;
                        color: grey;
                        letter-spacing: ${this.props.active ? '0' : '0.252px'};
                        text-align: center;
                    `}
                    >
                        {this.props.description}
                    </div>
                ) : null}
            </div>
        )
    }
}

const SegmentedControlButton = ({ onClick, className, disabled, children }) => (
    <div
        onClick={e => {
            if (disabled) {
                return
            }
            onClick(e)
        }}
        className={cx(
            css`
            position: absolute;
            top: 0;
            width: 35px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #fff;
        `,
            disabled ? css`
            color: #aaaaaa;
            cursor: not-allowed;
            ` : css`
                cursor: pointer;
            `,
            className
        )}
    >
        {children}
    </div>
)

const SegmentedControlPrevButton = props => (
    <SegmentedControlButton
        {...props}
        className={css`
            right: 0;
        `}
    >
        {arrowRight({ width: 16 })}
    </SegmentedControlButton>
)

const SegmentedControlNextButton = props => (
    <SegmentedControlButton
        {...props}
        className={css`
        left: 0;
    `}
    >
        {arrowLeft({ width: 16 })}
    </SegmentedControlButton>
)
class SegmentedControl extends React.Component {

    container = null
    content = null

    state = {
        changed: false,
        paginated: false,
        offset: 0,
        index: 0
    }

    constructor(props) {
        super(props)
        this.handleResize = debounce(this.initialize, 200)
    }

    componentDidMount() {

        this.initialize()
        window.addEventListener('resize', this.handleResize)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.items !== this.props.items) {
            this.initialize()
        }
    }

    initialize = () => {

        const { container, content } = this

        const offset = container.clientWidth - content.clientWidth - 70

        const itemWidth = this.props.itemWidth
        const pageWidth = container.clientWidth - 70
        const itemsPerPage = Math.floor(pageWidth / itemWidth)
        const maxIndex = this.props.items.length - itemsPerPage

        this.setState({
            changed: false,
            paginated: content.clientWidth > container.clientWidth,
            pageWidth,
            itemsPerPage,
            itemWidth,
            maxIndex,
            offset,
            index: 0
        })
    }

    handlePrev = () => {
        console.log('handlePrev')
        this.setState({
            changed: true,
            index: Math.max(this.state.index - this.state.itemsPerPage, 0)
        })
    }

    handleNext = () => {
        console.log('handleNext')
        this.setState({
            changed: true,
            index: Math.min(this.state.index + this.state.itemsPerPage, this.state.maxIndex)
        })
    }

    render() {

        console.log({
            state: this.state
        })

        const translate = this.state.offset + (this.state.index * this.state.itemWidth)

        console.log('offset', this.state.offset)
        console.log('pageSize', this.state.itemWidth)
        console.log('translate', translate)

        return (
            <div
                ref={ref => this.container = ref}
                className={css`
                    max-width: 100%;
                    overflow: hidden;
                    position: relative;
                    -webkit-box-shadow: 0 0 0 1px rgba(0,0,0,.09), 0 1px 0 0 rgba(0,0,0,.1), 0 1px 2px 0 rgba(0,0,0,.1);
                    box-shadow: 0 0 0 1px rgba(0,0,0,.09), 0 1px 0 0 rgba(0,0,0,.1), 0 1px 2px 0 rgba(0,0,0,.1);
                    border-radius: 5px;
                `}
            >
                <div
                    ref={ref => this.content = ref}
                    className={cx(
                        css`
            font-size: 15px;
            overflow: hidden;
            display: flex;
            align-items: center;
            display: inline-flex;
        `,
                        this.state.changed ? css`
        transition: 200ms transform ease;
        ` : null,
                        this.state.paginated ? css`
                        border-left: 1px solid #f2f2f2;
                        border-right: 1px solid #f2f2f2;
        margin-left: 35px;
        margin-right: 35px;
            ` : null
                    )}
                    style={this.state.paginated ? {
                        transform: `translateX(${translate}px)`
                    } : null}
                >
                    {this.props.children}
                </div>
                {this.state.paginated ? (
                    <SegmentedControlNextButton disabled={this.state.index === this.state.maxIndex} onClick={this.handleNext} />
                ) : null}
                {this.state.paginated ? (
                    <SegmentedControlPrevButton disabled={this.state.index === 0} onClick={this.handlePrev} />
                ) : null}
            </div>
        )
    }
}

const getEntityState = ({ entityTypeId, contractMonths, contractYears }) => {

    let entities = null
    let entityId = null

    if (entityTypeId === 'ContractMonth') {
        entities = contractMonths
        entityId = contractMonths.length ? contractMonths[contractMonths.length - 1].id : null
    }

    if (entityTypeId === 'ContractYear') {
        entities = contractYears
        entityId = contractMonths.length ? contractYears[contractYears.length - 1].id : null
    }

    return { entities, entityId }
}

class ContractStatistics extends React.Component {

    state = {
        loading: true,
        data: null,
        entityTypeId: 'ContractMonth',
        entityId: null,
        entities: [],
        entityTypes: [
            { id: 'ContractMonth', name: 'Maanden' },
            { id: 'ContractYear', name: 'Jaren' }
        ]
    }

    componentDidMount() {
        this.fetch()
    }

    componentDidUpdate() {

    }

    fetch = async () => {

        const response = await api.request({
            method: 'post',
            data: {
                query: `
                    query contractStatistics($id: ID!) {
                        viewer {
                            contractStatistics(id: $id)
                        }
                    }
                `,
                variables: {
                    id: this.props.recordId
                }
            }
        })

        const data = response.data.data.viewer.contractStatistics

        const contractYears = data.contractYears.map(contractYear => ({
            id: contractYear.id,
            name: contractYear.name
        }))

        const contractMonths = data.contractMonths.map(contractMonth => ({
            id: contractMonth.id,
            name: moment(contractMonth.date).format('MMMM'),
            description: moment(contractMonth.date).format('YYYY')
        }))

        const { entities, entityId } = getEntityState({
            entityTypeId: this.state.entityTypeId,
            contractMonths,
            contractYears
        })

        const contractYearsById = data.contractYears.reduce((result, contractYear) => {
            result[contractYear.id] = contractYear
            return result
        }, {})

        const contractMonthsById = data.contractMonths.reduce((result, contractMonth) => {
            result[contractMonth.id] = contractMonth
            return result
        }, {})

        this.setState({
            loading: false,
            data,
            contractYearsById,
            contractMonthsById,
            contractYears,
            contractMonths,
            entities,
            entityId
        })
    }

    handlePageSizeChange = (pageSize) => {
        this.setState({
            pageSize
        })
    }

    handlePageSizeChange = (pageSize) => {
        this.setState({
            pageSize
        })
    }

    handleEntityTypeClick = ({ id }) => {

        const { entities, entityId } = getEntityState({
            entityTypeId: id,
            contractMonths: this.state.contractMonths,
            contractYears: this.state.contractYears
        })

        this.setState({
            entityTypeId: id,
            entities,
            entityId
        })
    }

    handleEntityClick = ({ id }) => {

        this.setState({
            entityId: id
        })
    }

    render() {

        return (
            <div>
                <h2>{this.props.component.name}</h2>
                {this.state.entityId
                    ? this.renderContent()
                    : this.renderEmptyState()
                }
            </div>
        )
    }

    renderEmptyState() {

        return (
            <Box>
                <div
                className={css`
                    height: 500px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                `}
            >
                <div
                    className={css`
                        font-weight: bold;
                        margin-bottom: 8px;
                        font-size: 16px;
                    `}
                >
                    Nog geen statistieken beschikbaar
                </div>
                <div
                    className={css`
                        color: #aaa;
                    `}
                >
                    Dit contract heeft nog geen data opgebouwd
                </div>
            </div>
            </Box>
        )
    }

    renderContent() {

        if (this.state.loading) {
            return spinner({ width: 24 })
        }

        const components = {
            ContractMonth: {
                source: this.state.contractMonthsById[this.state.entityId],
                Chart: ContractMonthChart,
                Block1: ContractMonthDTGCard,
                Block2: ContractMonthDebtorTrajectoryCountCard,
                Block3: ContractMonthDebtorTrajectoryDayCountCard,
            },
            ContractYear: {
                source: this.state.contractYearsById[this.state.entityId],
                Chart: ContractYearChart,
                Block1: ContractYearDTGCard,
                Block2: ContractYearDebtorTrajectoryCountCard,
                Block3: ContractYearDebtorTrajectoryDayCountCard,
            }
        }

        const { source, Chart, Block1, Block2, Block3 } = components[this.state.entityTypeId]

        return (
            <div>
                <div
                    className={css`
                        display: flex;
                        align-items: center;
                        margin-bottom: 16px;
                    `}
                >
                    <div
                        className={css`
                            margin-left: auto;
                        `}
                    >
                        <SegmentedControl
                            itemWidth={110}
                            items={this.state.entityTypes}
                        >
                            {this.state.entityTypes.map(entityType => (
                                <SegmentedControlItem
                                    id={entityType.id}
                                    name={entityType.name}
                                    active={entityType.id === this.state.entityTypeId}
                                    onClick={this.handleEntityTypeClick}
                                    width={110}
                                />
                            ))}
                        </SegmentedControl>
                    </div>
                </div>
                <div
                    className={css`
                        display: flex;
                        align-items: center;
                        margin-bottom: 32px;
                    `}
                >
                    <div
                        className={css`
                        margin-left: auto;
                        max-width: 100%;
                    `}
                    >
                        <SegmentedControl
                            itemWidth={110}
                            items={this.state.entities}
                        >
                            {this.state.entities.map(entity => (
                                <SegmentedControlItem
                                    id={entity.id}
                                    name={entity.name}
                                    description={entity.description}
                                    active={entity.id === this.state.entityId}
                                    onClick={this.handleEntityClick}
                                    width={110}
                                />
                            ))}
                        </SegmentedControl>
                    </div>
                </div>
                <div>
                    <div
                        className={css`
                                margin-bottom: 32px;
                        `}
                    >
                        <Chart
                            recordId={this.state.entityId}
                            source={source}
                        />
                    </div>
                    <div className="row">
                        <div className="col">
                            <Block1
                                component={{
                                    name: 'Gemiddelde DTG'
                                }}
                                recordId={this.state.entityId}
                                source={source}
                            />
                        </div>
                        <div className="col">
                            <Block2
                                component={{
                                    name: 'Aantal achterstandstrajecten'
                                }}
                                recordId={this.state.entityId}
                                source={source}
                            />
                        </div>
                        <div className="col">
                            <Block3
                                component={{
                                    name: 'Totaal aantal dagen in achterstandstraject'
                                }}
                                recordId={this.state.entityId}
                                source={source}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ContractStatistics